/**
 * Global flag to show a message in Admin Connect only from clients.
 * Set to true to enable the message display.
 */
export let showAdminConnectClientMessage = false;
export let showPayrollConnectClientMessage = false;
